import { useState } from "react";
import axiosInstance from "./apiClient";

type FetchConfig = {
  data?: any; // for POST/PUT requests
  params?: Record<string, any>; // for query string parameters like ?category=DRIVER
};

const useParamsAuth = <T>(
  url: string,
  method: "GET" | "POST" | "PUT" | "DELETE" = "GET",
  responseType: "json" | "blob" = "json",
  transform?: (data: T) => T
) => {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async (config: FetchConfig = {}) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance({
        url,
        method,
        data: config.data || null,
        params: config.params || {},
        responseType,
      });

      const responseData = responseType === "blob"
        ? (response.data as T)
        : response.data;

      setData(transform ? transform(responseData) : responseData);

    } catch (err: any) {
      setError(err.response?.data?.message || err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const resetData = () => setData(null);

  return {
    data,
    error,
    loading,
    fetchData,
    resetData,
  };
};

export default useParamsAuth;
